<template>
  <ion-page>
    <master-layout pageTitle="Login Form">
      <ion-card-header>
        <ion-card-title>Dashboard Page</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <div class="table-responsive">
          <table id="table_id" class="table">
            <thead>
            <tr>
              <th>Column 1</th>
              <th>Column 2</th>
              <th>Column 3</th>
              <th>Column 4</th>
              <th>Column 5</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Row 1 Data 1</td>
              <td>Row 1 Data 2</td>
              <td>Row 1 Data 3</td>
              <td>Row 1 Data 4</td>
              <td>Row 1 Data 5</td>
            </tr>
            <tr>
              <td>Row 2 Data 1</td>
              <td>Row 2 Data 2</td>
              <td>Row 2 Data 3</td>
              <td>Row 2 Data 4</td>
              <td>Row 2 Data 5</td>
            </tr>
            </tbody>
          </table>
        </div>
      </ion-card-content>
    </master-layout>
  </ion-page>
</template>

<script>

import {mapGetters, mapActions} from "vuex";
import {
  IonCardHeader, IonCardTitle, IonCardContent,IonPage
} from "@ionic/vue";

export default {
  created()
  {
    window.$ = window.jquery = require('jquery');
    window.dt = require('datatables.net');
    window.$(document).ready(function ()
    {
      window.$('#table_id').DataTable();
    })
  },
  components: {
    IonCardHeader, IonCardTitle, IonCardContent,IonPage
  },
  computed: {
    ...mapGetters("app", {
      gettersAllStates: "getAllStates"
    }),
    ...mapGetters("auth", {
      gettersAuthData: "getAuthData",
    }),
  },

  methods: {
    ...mapActions("app", {
      actionsGetAllStates: 'getAllStates'
    })
  }
};
</script>

<style scoped>

</style>